import React from 'react';
import { Input } from 'antd';
import './sensorData.css';
import { Dropdown } from "react-bootstrap";
import { withRouter, RouteComponentProps } from 'react-router';
import Constants from '../../config/constants'
import Pagination from "react-js-pagination";
import {Organization} from '../../interface'
import {SensorBox} from '../../interface'
import sensorService from '../../services/sensorService'
import SensorBoxForm from '../../components/sensormodal'
import constants from '../../config/constants';
import toast from '../../components/toast'
import LoadingWheel from '../../components/loadingwheel'
import SensorData from '../../components/sensordata'
import Utility from '../../helpers/Utility';
import ExportModal from '../../components/exportsensordata'
import userService from '../../services/userService';
import eventStore from '../../store/eventStore';
import authStore from '../../store/authStore';
import Select from '../../components/select';
import ResetHardeleteSensorbox from '../../components/resetHarddeleteModal'
import Utils from '../../helpers/Utility';
import CreateGroupModal from '../../components/creategroupmodal/CreateGroupModal';
import groupIcn from '../../assets/group.png';
import sensorIcn from '../../assets/sensorbox.png';
import CheckIcon from "../../assets/images/check-ai.png";
import CrossIcon from "../../assets/images/cross-ai.png";
import WarningIcon from "../../assets/images/warning-ai.png";
import NAIcon from "../../assets/images/na-ai.png";
import organizationService from '../../services/organizationService';
import GraphModal from '../../components/graphmodal'
import GraphModalGroup from '../../components/graphModalgroup/GraphModalGroup'
import MaintenanceModal from '../../components/maintenancemodal';
import AlertLogsModal from '../../components/AlertLogsModal';
import LogDataModal from "../../components/LogDataModal"
import Routes from '../../routing/routes'
import Permissions from '../../config/permssions';
import DeviceConfigLogModal from '../../components/device-config-log-modal/DeviceConfigLogModal';
import moment from 'moment'
import InvalidRangeAlertModal from "../../components/InvalidRangeAlertModal/InvaliRangeAlertModal";
import DatePicker from '../../components/datepicker';
import AssetLogsModal from '../../components/AssetLogsModal';
import AssetDetailsModal from '../../components/AssetDetailsModal';
import ruleAlertService from '../../services/ruleAlertService';

const {
    view_only_partial_asset_sensorbox_details,
    create_edit_issue_tracker
  } = Permissions
const { Search } = Input;

const {
    super_admin_access,
    view_all_sensorboxes_assets,
    view_assigned_users_sensorboxes_assets,
    create_or_update_sensorboxes_assets
  } = Permissions

const deploymentStatusType = [
    { _id: 'commissioned', name: 'Commissioned' },
    { _id: 'decommissioned', name: 'Decommissioned' },
    { _id: 'tested', name: 'Tested' },
    { _id: 'testing', name: 'Testing' },
    { _id: '', name: 'All' }
]

export const deviceExamplesForDemo = new Map<string,string[]>([
    ["chiller-larger",['61782ba5128d3a2d981ab42d']],
    ["chiller-smaller",['']],
    ["RTU",['617838e0128d3a2d981b04b4']],
    ["Water-Heater",['6411dfd76f94297136f4fb13','6411de6c6f94297136f4e2a0']],
    ["Freezer",[]],
    ["Cooler",[]],
    ["MRI",[]],
    ["paw",[]],
    ["Indoor",[]],
    ["Outdoor",[]],
    ["O2-generator",[]],
    ["Chromalox",[]],
    ["boiler",[]],
    ["water pump",['6480e1131518cf6b17ee4229',]],
])

export interface SensorProps extends RouteComponentProps { }
export interface SensorState {
    sensorBoxList: Array<any>
    currentPage: number;
    visible         : boolean;
    organizationList:   Array<Organization>;
    organizationFilter? : any;
    sensorBoxCount: number;
    searchFilter: any;
    isLoading: boolean;
    selectedDeploymentStatus? : any;
    selectedSensorBox?   :   SensorBox;
    selectedSensorBoxName: string;
    selectedGroupId : string;
    selecetedSensorBox: any;
    contractorList: Array<any>
    contractor: any;
    showSensorDataModal: boolean;
    showGraphModal: boolean;
    showGraphModalForGroup: boolean;
    showMaintenanceModal: boolean;
    showExportModal: boolean;
    showAlertLogsModal: boolean;
    showAssetLogsModal: boolean;
    showInvalidRangeAlertModal:boolean;
    showAssetDetailsModal: boolean;
    selectedAsset: any;
    deviceSort: string;
    statusSort: string;
    isLogDataVisible:boolean;
    isInvalidRangeDataVisible:boolean;
    createGroupModalVisible: boolean;
    showResetSensorBoxModal: boolean;
    selectedLog:any;
    selectedAssetLog:any;
    invalidRangeAlertData:any;
    DeviceConfigLogModalVisible: boolean;
    lastTab:string,
    selectedDate: Date | null;
    commissionedDate:string;
    sensorboxStatuses:Array<any>
    sensorboxGroupStatuses:Array<any>
    groupedSensorBoxList:Array<any>
    rulesStatusMap: Record<string, { asset_type: string | null, hasRules: boolean, rulesCount: number, updatedAt: number | null }>
}

let system_id:any
let status:any
let org_id:any
let deployment_status: any

class UserList extends React.Component<SensorProps, SensorState> {

    

    searchSensorBoxes: any
    constructor(props: any) {
        super(props);

        const { location } = this.props
        const urlParams = new URLSearchParams(location?.search);
        system_id = urlParams.get('system_id')
        status = urlParams.get('status')
        org_id = urlParams.get('org_id')
        deployment_status = urlParams.get('deployment_status')


        this.state = {
            selectedSensorBox   :   undefined,
            sensorBoxList: [],
            visible         :   false,
            currentPage: 1,
            organizationList    : [],
            organizationFilter : {},
            sensorBoxCount: 1,
            searchFilter: '',
            isLoading: true,
            selectedSensorBoxName: '',
            selecetedSensorBox: {},
            selectedDeploymentStatus : deploymentStatusType[0]?._id,
            selectedGroupId:'',
            contractorList: [],
            contractor: '',
            showGraphModal: false,
            showGraphModalForGroup: false,
            showMaintenanceModal: false,
            showSensorDataModal: false,
            showExportModal: false,
            showAlertLogsModal: false,
            showAssetLogsModal: false,
            showInvalidRangeAlertModal:false,
            createGroupModalVisible: false,
            showAssetDetailsModal: false,
            selectedAsset: null,
            DeviceConfigLogModalVisible: false,
            deviceSort: 'group', // group or sensorbox
            statusSort: 'desc', // asc or desc,
            isLogDataVisible:false,
            isInvalidRangeDataVisible:false,
            showResetSensorBoxModal: false,
            selectedLog:{},
            selectedAssetLog:{},
            invalidRangeAlertData:{},
            lastTab:'status',
            selectedDate: null,
            commissionedDate:"",
            sensorboxStatuses: [], 
            sensorboxGroupStatuses: [], 
            groupedSensorBoxList: [],
            rulesStatusMap: {} as Record<string, { asset_type: string | null, hasRules: boolean, rulesCount: number, updatedAt: number | null }>
        }
        this.searchSensorBoxes = Utility.debounce(this.getSensorBoxes, 700);
        
    }

    async componentDidMount() {

        // note : temp solution for the org admin access to all org
        if(authStore?.isSuperAdmin || (authStore?.isOrgAdmin() && authStore.currentUser.is_default)){
            await this.getOrganisationsSensorData();
        }
        if(authStore?.currentUser?.access?.includes(view_all_sensorboxes_assets)){
            await this.getContractorList()
        }
        await this.getSensorBoxes(1);
        this.listenAndUpdateSensordata()
    }


    getSensorBoxes: any = async (pageNumber: number = 0) => {
        pageNumber = pageNumber === 0 ? this.state.currentPage : pageNumber;
        try {
            this.setState(state=>({...state,isLoading:true}));
            let sensorBoxList:any;
            const demoCheck = (authStore?.currentUser?.active_role?.role_type === -1);
            const getSensorBoxes = demoCheck ? sensorService.getSensorBoxesForDemo : sensorService.getSensorBoxes

            sensorBoxList = await getSensorBoxes(pageNumber, constants.maxLimit, this.state.contractor, this.state.searchFilter, this.state.deviceSort, this.state.statusSort,org_id ? org_id : this.state.organizationFilter._id, system_id ? system_id : null , status ?  status : null, true, deployment_status ? deployment_status : this.state?.selectedDeploymentStatus, this.state?.commissionedDate != "" ? this.state?.commissionedDate : null, true) as any
           
            if(demoCheck){
                this.redact(sensorBoxList.result);
            }

            let flattenedList : any = [];
            sensorBoxList.result.forEach(item => {
                if (item.assets || item.sensor_boxes) {
                  // This is an asset group - extract its contents
                  if (item.assets && item.assets.length > 0) {
                    item.assets.forEach(asset => {
                      // Add the asset to the flattened list
                      flattenedList.push(asset);
                    });
                  }
                  
                  if (item.sensor_boxes && item.sensor_boxes.length > 0) {
                    item.sensor_boxes.forEach(sensorBox => {
                      // Add the sensor box to the flattened list
                      flattenedList.push(sensorBox);
                    });
                  }
                } else {
                  // This is already an individual item, add it directly
                  flattenedList.push(item);
                }
            });

            this.setState(state=>({...state, sensorBoxList: flattenedList, sensorBoxCount: sensorBoxList.count, currentPage: pageNumber, isLoading: false }))
            // this.setState(state=>({...state, sensorBoxCount: sensorBoxList.count, currentPage: pageNumber, isLoading: false }))
            
            this.checkSensorMinMax(flattenedList)
            this.fetchRulesStatus(flattenedList)
        } catch (error) {            
            if (error.message !== "Operation canceled due to new request.") {
                this.setState({ isLoading: false })
                toast.error(error.response?.data?.message)
            }
        }
    }

    fetchRulesStatus = async (sensorBoxList: any) => {
        // Only fetch if user is org admin or super admin
        if (!authStore?.isOrgAdmin() && !authStore?.isSuperAdmin) {
            return;
        }

        try {
            const assetIds: string[] = [];

            // Collect all asset IDs from the list
            sensorBoxList.forEach((item: any) => {
                if (item.group === 1) {
                    // Sensorbox group - use _id
                    if (item._id) {
                        assetIds.push(item._id);
                    }
                    // Also collect individual sensorboxes in the group
                    if (item.sensorboxes && item.sensorboxes.length > 0) {
                        item.sensorboxes.forEach((box: any) => {
                            // if (box._id) {
                            //     assetIds.push(box._id);
                            // } else if (box.sensor_box_name) {
                            // }
                            assetIds.push(box.sensor_box_name);
                        });
                    }
                } else {
                    // Individual sensorbox - use _id or sensor_box_name
                    // if (item._id) {
                    //     assetIds.push(item._id);
                    // } else if (item.sensor_box_name) {
                    // }
                    assetIds.push(item.sensor_box_name);
                }
            });

            if (assetIds.length > 0) {
                const rulesStatus = await ruleAlertService.checkRulesStatusForAssets(assetIds);
                this.setState({ rulesStatusMap: rulesStatus });
            }
        } catch (error) {
            console.error("Error fetching rules status:", error);
        }
    }

    checkSensorMinMax(sensorBoxList: any) {
        let sensorBoxes = sensorBoxList;        
        const validPinTypes = ["current", "temperature", "pressure", "voltage", "vibration"];
        const thirtyDaysAgo = new Date().getTime() - 30 * 24 * 60 * 60 * 1000;    // 30 days ago

        let boxStatus: any = []
        let boxGroupStatus: any = []
        sensorBoxes.forEach((item:any) => {
            // calculate for asset grups
            if (item.assets || item.sensor_boxes) {
                item.assets.forEach((asset:any) => {
                    let isGroupValid = "NA";

                    asset.sensorboxes.forEach((sensorbox:any) => {
                        let isValid = "NA"; 
                        let resp = this.checkLimitofAssets(sensorbox, validPinTypes, thirtyDaysAgo, isGroupValid)
                        isValid = resp.isValid
                        isGroupValid = resp.isGroupValid
        
                        boxStatus.push({
                            sensorboxId: sensorbox._id,
                            status: isValid
                        })
                    });
                    boxGroupStatus.push({
                        sensorboxId: asset._id,
                        status: isGroupValid
                    })
                });
                
                item.sensor_boxes.forEach((sensorbox:any) => {
                    // calculate for individual sensorbox
                    let isGroupValid = this.checkLimitsofIndividualBox(sensorbox, validPinTypes, thirtyDaysAgo)
                    boxGroupStatus.push({
                        sensorboxId: sensorbox._id,
                        status: isGroupValid
                    })
                })
                
            } else if (item.sensorboxes) {
                let isGroupValid = "NA";
                // calculate for sensorbox groups (assets)
                item.sensorboxes.forEach((sensorbox:any) => {
                    let isValid = "NA"; 
                    let resp = this.checkLimitofAssets(sensorbox, validPinTypes, thirtyDaysAgo, isGroupValid)
                    isValid = resp.isValid
                    isGroupValid = resp.isGroupValid
    
                    boxStatus.push({
                        sensorboxId: sensorbox._id,
                        status: isValid
                    })
                });
                boxGroupStatus.push({
                    sensorboxId: item._id,
                    status: isGroupValid
                })
            } else {
                // calculate for individual sensorbox
                let isGroupValid = this.checkLimitsofIndividualBox(item, validPinTypes, thirtyDaysAgo)
                boxGroupStatus.push({
                    sensorboxId: item._id,
                    status: isGroupValid
                })
            }

        });

        this.setState({sensorboxStatuses: boxStatus, sensorboxGroupStatuses: boxGroupStatus});
    }

    checkLimitofAssets(sensorbox: any, validPinTypes: any, thirtyDaysAgo: any, isGroupValid: any) {
        let isValid = "NA"; 

        for (let index = 0; index < sensorbox.sensors.length; index++) {
            const sensor = sensorbox.sensors[index];
            if (validPinTypes.includes(sensor.pin_type) && sensor.auto_limit) {
                let min = Number(sensor.sensor_type?.min || 0);
                let max = Number(sensor.sensor_type?.max || 0);
                if (min === 0 && max === 0) {
                    isValid = "NEW";
                    break;
                } else if (min !== Number(sensor.auto_limit?.latest_estimation?.min) || max !== Number(sensor.auto_limit?.latest_estimation?.max)) {
                    isValid = "NO";
                } else if (isValid !== "NO") {
                    isValid = "YES";
                }
            }
        }

        if (isValid === "NO") {
            for (let index = 0; index < sensorbox.sensors.length; index++) {
                const sensor = sensorbox.sensors[index];
                if (sensor.sensor_type?.limit_updated_at > thirtyDaysAgo) {
                    // Updated within the last 30 days
                    isValid = "YES";
                    break;
                }
            }
        }

        if (isValid !== "NA") {
            if (isValid === "NEW") {
                isGroupValid = "NEW"; 
            } else if (isValid === "NO" && isGroupValid !== "NEW") {
                isGroupValid = "NO";
            } else if (isValid === "YES" && isGroupValid !== "NEW" && isGroupValid !== "NO") {
                isGroupValid = "YES";
            }
        }

        return {isValid, isGroupValid}
    }

    checkLimitsofIndividualBox(sensorbox: any, validPinTypes: any, thirtyDaysAgo: any) {
        let isGroupValid = "NA";
        for (let index = 0; index < sensorbox.sensors.length; index++) {
            const sensor = sensorbox.sensors[index];
            if (validPinTypes.includes(sensor.pin_type) && sensor.auto_limit) {
                let min = Number(sensor.sensor_type?.min || 0);
                let max = Number(sensor.sensor_type?.max || 0);
                if (min === 0 && max === 0) {
                    isGroupValid = "NEW";
                    break;
                } else if (min !== Number(sensor.auto_limit?.latest_estimation?.min) || max !== Number(sensor.auto_limit?.latest_estimation?.max)) {
                    isGroupValid = "NO"; 
                } else if (isGroupValid !== "NO") {
                    isGroupValid = "YES";
                }
            }
        }

        if (isGroupValid === "NO") {
            for (let index = 0; index < sensorbox.sensors.length; index++) {
                const sensor = sensorbox.sensors[index];
                if (sensor.sensor_type?.limit_updated_at > thirtyDaysAgo) {
                    // Updated within the last 30 days
                    isGroupValid = "YES";
                    break;
                }
            }
        }

        return isGroupValid;
    }

    updateOfflineStatus(event_data: any){
        let sensorBoxes = this.state.sensorBoxList;        
        if(event_data?.groupId) {
            let deviceIndex = sensorBoxes?.findIndex((device: any) => device?._id === event_data?.groupId);
            if(deviceIndex >= 0 ) {
                let childIndex = sensorBoxes[deviceIndex]?.sensorboxes.findIndex((sb: any) => sb?.sensor_box_name === event_data.sensor_box_name);
                if(childIndex >= 0) {
                    if(sensorBoxes[deviceIndex].sensorboxes[childIndex].is_online !== event_data?.data?.is_online){
                        sensorBoxes[deviceIndex].sensorboxes[childIndex].is_online = event_data?.data?.is_online;
                        this.setState({ sensorBoxList: sensorBoxes })
                    }

                }
            }
        }else {
            let sensorboxIndex = sensorBoxes?.findIndex((sb: any) => sb?.sensor_box_name === event_data.sensor_box_name);
            if(sensorboxIndex >= 0) {
                if(sensorBoxes[sensorboxIndex].is_online !== event_data?.data?.is_online){
                    sensorBoxes[sensorboxIndex].is_online = event_data?.data?.is_online;
                    this.setState({ sensorBoxList: sensorBoxes })
                }
            }
        } 
    }

    updateConfigStatus(eventdata : any){

        const sensorboxes = this.state.sensorBoxList.slice();
        if(eventdata?.groupId) {
          let deviceIndex = sensorboxes?.findIndex((device: any) => device?._id === eventdata?.groupId);
          if(deviceIndex >= 0 ) {
            let childIndex = sensorboxes[deviceIndex]?.sensorboxes.findIndex((sb: any) => sb?.sensor_box_name === eventdata?.sensor_box_name);
            if(childIndex >= 0) {
              sensorboxes[deviceIndex].sensorboxes[childIndex].device_config_status = eventdata?.data?.status;
            }
          }
        }else {
          let index = sensorboxes.findIndex(s => s?.sensor_box_name === eventdata?.sensor_box_name);
          if(index >= 0) {
            sensorboxes[index].device_config_status = eventdata?.data?.status;
          }
        }
        this.setState({ sensorBoxList: sensorboxes });
  
        if(this.state.selectedSensorBox?.sensor_box_name === eventdata?.sensor_box_name) {
          const sensorbox = { ...this.state.selectedSensorBox, device_config_status: eventdata?.data?.status } as SensorBox
          this.setState({ selectedSensorBox: sensorbox })
        }

    }

    listenAndUpdateSensordata = () => {
        if (eventStore.eventSource) {
            let that = this
            eventStore.eventSource.onmessage = function (event) {
                if (event.data !== "CONNECTED") {
                    let event_data = JSON.parse(event.data);
                    if(event_data?.type === "OFFLINE_STATUS_UPDATE") {
                        that.updateOfflineStatus(event_data)
                        return
                    }

                    if(event_data?.type === "CONFIG_UPDATE") {
                        that.updateConfigStatus(event_data)
                        return
                    }

                    let newSensorBoxList = Utility.updateSensoBoxData(that.state.sensorBoxList, event_data)
                    that.setState({ sensorBoxList: newSensorBoxList })
                }
            }
        }
    }

    setSearchFilter(value: string) {
        this.setState({ searchFilter: value, currentPage: 1 }, () => {
            this.searchSensorBoxes()
        })
    }

    getOrganisationsSensorData :any = async () => {
        try {
                const response = await organizationService.getOrganizations()
                this.setState({organizationList : response.data.organizations , organizationFilter : response.data.organizations[0]})
        } catch (error) {
                toast.error(error.response.data.message)
                this.setState({isLoading : false})
        }
    }

    clearSelect = () => {
        this.setState({selectedSensorBox : {} as SensorBox})
    }

    showResetSensorBoxModal(item : any) {
        this.setState({ selectedSensorBox : item ,showResetSensorBoxModal :true })
    }

    handleFilterOrganization(option: any){
        this.setState({organizationFilter : option},()=>{
            // note : temp solution for the org admin access to all org
           this.getContractorList()
           this.getSensorBoxes(1);
        })
    }

    handleDeploymentStatus(option: any){      
        this.setState({selectedDeploymentStatus : option?._id},()=>{
            // note : temp solution for the org admin access to all org
           this.getSensorBoxes(1);
        })
        if(option?._id != "commissioned"){
            this.setState({ commissionedDate: '' })
        }
    }

    shouldPageChange = (isAdd: boolean) => {
        let currentPage = 0;
        if (isAdd) {
          currentPage = Math.ceil( (this.state.sensorBoxCount + 1)/constants.maxLimit );
        } else if(this.state.sensorBoxList.length === 1 && this.state.currentPage > 1) {
          currentPage = this.state.currentPage -1
        }
    
        return currentPage;
      }
    

    showSensordataModal(sensorDetails: any) {
        this.setState({ selecetedSensorBox: sensorDetails , showSensorDataModal :true })
        Utility.showModal('sensordetails')
    }

    closeSensordataModal = () => {
        this.setState({ selecetedSensorBox: {}  , showSensorDataModal :false})
        Utility.closeModal('sensordetails')
    }

    closeResetSensorBoxModal = () => {
        this.setState({ showResetSensorBoxModal: false })
    }

    showExportModal(exportData: any) {
        
        if(!exportData.group){
            this.setState({ selectedSensorBoxName: exportData.sensor_box_name, selecetedSensorBox: exportData, showExportModal :true})
        }else{
            this.setState({ selectedGroupId: exportData._id, selecetedSensorBox: exportData, showExportModal :true })
        }
    }

    closeExportModal = () => {
        this.setState({ selectedSensorBoxName: '', selecetedSensorBox: '', selectedGroupId:'', showExportModal :false })
    }

    showGraphModal(sensorDetails: any) {
        this.setState({
            selectedSensorBoxName: sensorDetails.sensor_box_name,
            selecetedSensorBox: sensorDetails,
            showGraphModal: true,
        })
        document.querySelector('body')?.classList.add('modal-open');
    }
    showGraphModalForGroup(sensorDetails: any) {
        this.setState({
            selectedSensorBoxName: sensorDetails.sensor_box_name,
            selecetedSensorBox: sensorDetails,
            showGraphModalForGroup: true
        })
        document.querySelector('body')?.classList.add('modal-open');
    }
    closeGraphModal = () => {
        this.setState({
            selectedSensorBoxName: '',
            selecetedSensorBox: {},
            showGraphModal: false,
        })
        document.querySelector('body')?.classList.remove('modal-open');
    }
    closeGroupGraphModal = () => {
        this.setState({
            selectedSensorBoxName: '',
            selecetedSensorBox: {},
            showGraphModalForGroup: false
        })
        document.querySelector('body')?.classList.remove('modal-open');
    }

    showMaintenanceModal = (sensorDetails: any) => {
        this.setState({
            selectedSensorBoxName: sensorDetails.sensor_box_name,
            selecetedSensorBox: sensorDetails,
            showMaintenanceModal: true
        })
    }

    closeMaintenanceModal = () => {
        this.setState({
            showMaintenanceModal: false
        })
    }


    async getContractorList() {
        try {

            let contractorList = await userService.getContractorList(this.state.organizationFilter._id)
            if(authStore?.currentUser?.active_role?.role_type === -1) {
                contractorList = contractorList.map((item: any, index :any) => ({...item, name: `Contractor ${index+1}`}))
            }

            this.setState({ contractorList: contractorList });

        } catch (error) {
            toast.error(error.response.data.message)
        }
    }

    updateContractor = async (contractor: any) => {
        this.setState({ contractor: contractor }, () => {
            this.getSensorBoxes(1)
        });
    }


    sortDevice = () => {
        const { deviceSort } = this.state;
        this.setState({ deviceSort: deviceSort === 'group' ? 'sensorbox' : 'group' }, () => {
          this.getSensorBoxes(1);
        })
      }
    
      sortStatus = () => {
        const { statusSort } = this.state;
        this.setState({ statusSort: statusSort === 'desc' ? 'asc' : 'desc' }, () => {
          this.getSensorBoxes(1);
        })
      }


    showAlertLogsModal = (sensorDetails: any) => {
        this.setState({
            selectedSensorBoxName: sensorDetails.sensor_box_name,
            selecetedSensorBox: sensorDetails,
            showAlertLogsModal: true,
            lastTab:'status'
        })
    }
    showAssetLogsModal = (sensorDetails: any) => {
        this.setState({
            selectedSensorBoxName:sensorDetails.group === 1 ?  sensorDetails.name : sensorDetails.sensor_box_name,
            selectedGroupId: sensorDetails.group === 1 ? sensorDetails._id : sensorDetails.sensor_box_name,
            selecetedSensorBox: sensorDetails,
            showAssetLogsModal: true,
            lastTab:'status'
        })
    }


    showIssueCreationPage = (sensorDetails: any) => {

        let orgid = org_id ? org_id : this.state.organizationFilter._id

        let params = `?system_id=${sensorDetails?._id}&status=${sensorDetails?.status}`

        if(authStore?.isSuperAdmin || (authStore?.isOrgAdmin() && authStore.currentUser.is_default)){
            params += `&org_id=${orgid}`
        }

        this.props.history.push({
            pathname: `${Routes.issuetrackerdetails}`,
            search: params,
          });
    }


    setVisible = () => {
        this.setState({visible:false});
    }

    closeAlertLogsModal = () => {
        this.setState({
            showAlertLogsModal: false,
            selectedSensorBoxName: '',
            selecetedSensorBox: {},
        })
    }
    closeAssetLogsModal = () => {
        this.setState({
            showAssetLogsModal: false,
            selectedSensorBoxName: '',
            selectedGroupId: '',
            selecetedSensorBox: {},
        })
    }

    showAssetDetailsModal = (asset: any) => {
        this.setState({
            selectedAsset: asset,
            showAssetDetailsModal: true
        })
    }

    closeAssetDetailsModal = () => {
        this.setState({
            showAssetDetailsModal: false,
            selectedAsset: null
        })
    }

    showLogDataModal = (logData: any) => {
        this.setState({ selectedLog: logData, isLogDataVisible: true, showAlertLogsModal: false })
    }

    showAssetLogDataModal = (logData: any) => {
        this.setState({ selectedAssetLog: logData, isLogDataVisible: true, showAssetLogsModal: false })
    }
    
    showInvalidRangeAlertModal = (logData: any) => {
        this.setState((state)=>({...state, invalidRangeAlertData: logData, isInvalidRangeDataVisible: true, showAlertLogsModal: false }))
    }

    closeLogDataModal = () => {
        this.setState({ selectedLog: {}, isLogDataVisible: false, showAlertLogsModal: true})
    }

    closeAssetLogDataModal = () => {
        this.setState({ selectedAssetLog: {}, isLogDataVisible: false, showAssetLogsModal: true})
    }

    // Sensorbox and asset alerts land in separate state, so each returns to its own modal.
    logDataModalProps = () => {
        const isSensorboxLog = Object.keys(this.state.selectedLog.components || {}).length > 0
        const log = isSensorboxLog ? this.state.selectedLog : this.state.selectedAssetLog
        return {
            logData: log.components,
            highlightKeys: log.highlightKeys,
            alertColor: log.alertColor,
            alertCode: log.alertCode,
            onClose: isSensorboxLog ? this.closeLogDataModal : this.closeAssetLogDataModal
        }
    }

    closeInvalidRangeAlertModal = () => {
        this.setState({ invalidRangeAlertData: {}, isInvalidRangeDataVisible: false, showAlertLogsModal: true,lastTab: 'invalid-range' })
    }

    onAddBtnClick = (eventKey: string | null) => {
        if(eventKey === 'group') {
          this.setState({ createGroupModalVisible: true })
        }else if(eventKey === 'sensorbox') {
          this.showSensorBoxForm()
        }
    }

    showSensorBoxForm(item? : SensorBox) {

        const regularUser = ((
          item?.contractor?.[0]?._id === authStore?.currentUser?.uid
            || ( authStore?.currentUser?.access.includes(view_assigned_users_sensorboxes_assets) ? item?.contractor?.[0]?._id === authStore?.currentUser?.assigned_to : false)
            || authStore?.currentUser?.active_role?.role_type < 2) 
        )
    
          if(item?.group) {
            const list = this.state.sensorBoxList.slice();
            let index = list.findIndex(d => item?._id === d?._id);
            list[index].open = !list[index].open;
            this.setState({
              sensorBoxList: list
            })
            return
          }
    
            if(item?.is_deleted){
              this.showResetSensorBoxModal(item)
            }else{
              if(item?.user_access?.includes(authStore?.currentUser?.uid ) && !regularUser){
                return
              }
              
              this.setState({selectedSensorBox : item, visible:true},()=>{
                Utility.showModal('sensorboxdetails')
              })
            }
    }

    resetSensorBox = async (item : any ,data : any) => {
        try {
            if(data === 'hardelete'){
                await userService.hardDeleteSensorBox(item?._id)
            }else{
                await userService.resetSensorBox(item._id)
            }
          this.setState({ showResetSensorBoxModal: false })
          await this.getSensorBoxes(this.state.currentPage)
        } catch (error) {
            toast.error(error.response.data.message)
        }
    }

    onClickShowAll =() => {
        this.props.history.push(Routes.systems);
        this.props.history.go(0)
    }

    showDeviceLog = (item: SensorBox) => {
        this.setState({selectedSensorBox : item, DeviceConfigLogModalVisible:true});
    }

    // Method to group sensor boxes by asset_group with preserved open/closed state
    groupSensorBoxesByAssetGroup = () => {
        const grouped = {};
        const ungrouped = {
            groupId: 'ungrouped',
            groupName: 'Ungrouped Devices',
            open: true, // Keep ungrouped items expanded by default
            items: []
        };
        
        // Get the current open states from the existing grouped list
        const currentOpenStates = {};
        if (this.state.groupedSensorBoxList) {
        this.state.groupedSensorBoxList.forEach(group => {
            if (group.groupId !== 'ungrouped') {
            currentOpenStates[group.groupId] = group.open;
            }
        });
        }
        
        this.state.sensorBoxList.forEach(item => {
        if (item.asset_group_id) {
            const groupId = item.asset_group_id;
            const groupName = item.asset_group_name;
            
            if (!grouped[groupId]) {
            // Preserve the open state if it exists, otherwise default to true
            const isOpen = currentOpenStates[groupId] !== undefined ? currentOpenStates[groupId] : true;
            
            grouped[groupId] = {
                groupId,
                groupName,
                open: isOpen, // Use preserved state or default to true
                items: []
            };
            }
            
            grouped[groupId].items.push(item);
        } else {
            ungrouped.items.push(item);
        }
        });
        
        // Return groups first, then ungrouped items
        return [...Object.values(grouped), ungrouped];
    };
    
    // Method to toggle asset group expansion
    toggleAssetGroup = (groupId) => {
        const groupedSensorBoxList = this.state.groupedSensorBoxList.map(group => {
        if (group.groupId === groupId) {
            return { ...group, open: !group.open };
        }
        return group;
        });
        
        this.setState({ groupedSensorBoxList });
    };

    // Update your componentDidUpdate or wherever you handle sensorBoxList changes
    componentDidUpdate(prevProps, prevState) {
        if (prevState.sensorBoxList !== this.state.sensorBoxList) {
            const groupedSensorBoxList = this.groupSensorBoxesByAssetGroup();
            this.setState({ groupedSensorBoxList });
        }
    }

    redact = (list) => {
        try{
            const clients = ['Kuehne Nagel','First Co'];
            for (const sb of list) {
                if (sb.group) {
                    for(const box of sb.sensorboxes){
                        if (box.alias) {
                            clients?.forEach(client => {
                                box.alias = box.alias.replace(client, '')
                            })
                        }

                    }
                }
            }
        }catch (e){
            console.log(e)
        }

    }

    render() {
        const demoCheck = (authStore?.currentUser?.active_role?.role_type === -1);
        const canCreateEditTickets = authStore?.currentUser?.access?.includes(create_edit_issue_tracker);
        const headerClassName = ['']
        if(authStore?.isOrgAdmin() && authStore?.currentUser?.is_default && !system_id && !status ){
            headerClassName.push(' col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-4')
        }
        else if(authStore?.currentUser?.active_role?.role_type > 1 && !system_id && !status){
            headerClassName.push(' col-md-10')
        }else if(authStore?.isSuperAdmin && !system_id && !status){
            headerClassName.push('col-xs-12 col-sm-12 col-md-4 col-lg-6 col-xl-6')
        }
        else{
            headerClassName.push('col-xs-12 col-sm-12 col-md-4 col-lg-6 col-xl-8')
        }

        let devicesWidth = '25%'
        let lastUpdatedWidth = '27%'
        let columnCount = 8
        if(authStore?.currentUser?.active_role?.role_type !== 4 && authStore?.currentUser?.active_role?.role_type !== 2) {
            devicesWidth = '22%'
            lastUpdatedWidth = '23%'
            columnCount++
        }

        // Add Tickets column for users with create edit tickets permission
        if(canCreateEditTickets) {
            devicesWidth = '18%'
            lastUpdatedWidth = '20%'
            columnCount++
        }

        const isSuperAdmin = authStore?.isSuperAdmin
        // Add Limits Setup column for super admin
        if (isSuperAdmin) {
            columnCount++
        }

        // Add Rules column for org admin and super admin
        if (authStore?.isOrgAdmin()) {
            columnCount++
        }


        const deploymentStatusValue = deploymentStatusType.find((status:any)=>(status?._id === this.state?.selectedDeploymentStatus))
        const onChangeDateHandler = async(value: any, type: any) => {
            this.setState({ selectedDate: value });
            if (value) {
                // const formattedDate = formatDate(value); // Format the date
                this.setState({ commissionedDate: value.getTime() },()=>{
                    // note : temp solution for the org admin access to all org
                   this.getSensorBoxes(1);
                }); // Update state
            } else {
                this.setState({ commissionedDate: '' },()=>{
                    // note : temp solution for the org admin access to all org
                   this.getSensorBoxes(1);
                }); // Clear state if no date is selected
            }
        }
        
        return (

            <div>
                <div className="row mb-25">
                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-2">
                        <p className="table-title media-padding">Details</p>
                    </div>        
                    {/* <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-2 media-margin-tp">
                        <label className="custom-label">Commissioned Date</label>
                        <DatePicker
                            placeholderText={!authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) ? "Choose date" : 'Date'}
                            value={this.state.commissionedDate  ? new Date(this.state.commissionedDate ) : null }
                            dateFormat="MM/dd/yyyy"
                            maxDate={new Date()}
                            isClearable={true}
                            onChange={(value: any) => {
                                onChangeDateHandler(value, 'commissioned_date')
                            }}
                         
                        />
                    </div>            */}

                        {(isSuperAdmin || (authStore?.isOrgAdmin() && authStore.currentUser.is_default)) && !system_id && !status &&
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-2 media-margin-tp">
                                <div className="filter-select">
                                    <label className="custom-label">Organization</label>
                                        <Select name="typeFilter"
                                                data={this.state.organizationList}
                                                value={this.state.organizationFilter}
                                                onChange={(e:any)=>this.handleFilterOrganization(e)}
                                        />
                                </div>
                            </div>
                        }
                        {(isSuperAdmin || (authStore?.isOrgAdmin() && authStore.currentUser.is_default)) && !system_id && !status &&
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-2 media-margin-tp">
                                <div className="filter-select">
                                    <label className="custom-label">Deployment Status</label>
                                        <Select name="typeFilter"
                                                data={deploymentStatusType}
                                                value={deploymentStatusValue}
                                                onChange={(e:any)=>this.handleDeploymentStatus(e)}
                                        />
                                </div>
                            </div>
                        }
                        {(isSuperAdmin || (authStore?.isOrgAdmin() && authStore.currentUser.is_default)) && !system_id && !status &&
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-2 media-margin-tp">
                                <label className="custom-label">Commissioned Date</label>
                                <DatePicker
                                    placeholderText={!authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) ? "Choose date" : 'Date'}
                                    value={this.state.commissionedDate  ? new Date(this.state.commissionedDate ) : null }
                                    dateFormat="MM/dd/yyyy"
                                    maxDate={new Date()}
                                    isClearable={true}
                                    onChange={(value: any) => {
                                        onChangeDateHandler(value, 'commissioned_date')
                                    }}
                                disabled={this.state?.selectedDeploymentStatus != "commissioned"}
                                />
                            </div>
                        }
                        {!authStore?.currentUser?.access?.includes(super_admin_access) && authStore?.currentUser?.access?.includes(view_all_sensorboxes_assets) && !system_id && !status &&
                            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-3 col-xl-2 media-margin-tp">
                                <div className="filter-select">
                                    <div className="form-group mb-0 select-clos-btn">
                                        <label className="custom-label">Contractor</label>
                                            <Select name="contractor"
                                                isDisabled={false}
                                                data={this.state.contractorList}
                                                value={this.state.contractor ? this.state.contractor : ''}
                                                onChange={(value: any) => this.updateContractor(value)}
                                                showClose={this.state.contractor && Object.keys(this.state.contractor).length !== 0}
                                                clearValue={() => this.updateContractor(null)}
                                            />
                                    </div>
                                </div>
                            </div>
                        }    
                        {  !system_id  && !status &&                 
                        <div className="col-xs-6 col-sm-6 col-md-6 col-lg-3 col-xl-2 media-margin-tp mt-auto">
                              <Search
                                placeholder="Search"
                                value={this.state.searchFilter ? this.state.searchFilter : ''}
                                size="large"
                                onChange={(e) => this.setSearchFilter(e.target.value)}
                                allowClear
                                enterButton />
                        </div>
                        }
                        {(system_id || status) &&
                            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-3 col-xl-4 media-margin-tp mt-auto text-right">
                                <button type="button" 
                                    disabled={false} 
                                    className="btn btn-primary show-all-btn"
                                    onClick={this.onClickShowAll}
                                >Show All
                                </button>
                            </div>
                        }

                </div>

                {this.state.sensorBoxList.length !== 0 ? (
                    <div className="table-wrap ">
                        <table className="table table-custom custom-table table-style table-hover responsive-table">
                        <thead className="table-header-bg">
                            <tr>
                            <th style={{ width: '2%' }} className="" scope="col"></th>
                            <th style={{ width: devicesWidth }} className="cursor-pointer" scope="col" onClick={this.sortDevice}>
                                Devices
                                <i className={`fa ml-3 ${this.state.deviceSort === 'group' ? 'fa-caret-up' : 'fa-caret-down'}`}></i>
                            </th>
                            <th style={{ width: lastUpdatedWidth }} className="" scope="col">Last Update</th>
                            <th style={{ width: '7%' }} className="text-center cursor-pointer" scope="col" onClick={this.sortStatus}>
                                Status
                                <i className={`fa ml-3 ${this.state.statusSort === 'desc' ? 'fa-caret-up' : 'fa-caret-down'}`}></i>
                            </th>
                            <th style={{ width: '7%' }} className="text-center" scope="col">View Details</th>
                            <th style={{ width: '7%' }} className="text-center" scope="col">Export</th>
                            <th style={{ width: '7%' }} className="text-center" scope="col">View Graph</th>
                            <th style={{ width: '7%' }} className="text-center" scope="col">Service History</th>
                            <th style={{ width: '7%' }} className="text-center" scope="col">Alert Logs</th>
                            {canCreateEditTickets && (
                                <th style={{ width: '7%' }} className="text-center" scope="col">Tickets</th>
                            )}
                            {(authStore?.currentUser?.active_role?.role_type !== 4 && authStore?.currentUser?.active_role?.role_type !== 2) && (
                                <th style={{ width: '7%' }} className="text-left" scope="col">Config</th>
                            )}
                            {( authStore?.isSuperAdmin) && (
                                <th style={{ width: '7%' }} className="text-center cursor-pointer" scope="col">Limits Setup</th>
                            )}
                            {(authStore?.isOrgAdmin()) && (
                                <th style={{ width: '7%' }} className="text-center" scope="col">Rules</th>
                            )}
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.groupedSensorBoxList ? (
                            this.state.groupedSensorBoxList.map((group, groupIndex) => (
                                <React.Fragment key={groupIndex}>
                                {/* Asset Group Header Row */}
                                {group.groupId !== 'ungrouped' && (
                                    <tr 
                                    className="group-header cursor-pointer" 
                                    onClick={() => this.toggleAssetGroup(group.groupId)}
                                    >
                                    <th scope="row">
                                        <i
                                        style={{ fontSize: 12 }}
                                        className={group.open ? 'fa fa-chevron-down' : 'fa fa-chevron-right'}
                                        aria-hidden="true"
                                        ></i>
                                    </th>
                                    <td colSpan={columnCount} className="font-weight-bold">
                                        {group.groupName} ({group.items.length} asset{group.items.length !== 1 ? 's' : ''})
                                    </td>
                                    </tr>
                                )}

                                {/* Asset Group Items */}
                                {(group.groupId === 'ungrouped' || group.open) &&
                                    group.items.map((item, index) => {
                                    const tableClassName = ['cursor-pointer'];
                                    if (item?.is_deleted) {
                                        tableClassName.push('sensordata-grey-tr');
                                    }

                                    // Add padding class for asset group children
                                    if (group.groupId !== 'ungrouped') {
                                        tableClassName.push('asset-group-child');
                                    }

                                    return (
                                        <React.Fragment key={`${groupIndex}-${index}`}>
                                        <tr
                                            className={tableClassName.join(' ')}
                                            onClick={(e) => {
                                            if (item?.group && !demoCheck) {
                                                // Open asset details modal for groups
                                                this.showAssetDetailsModal(item);
                                                return;
                                            } else {
                                                this.showSensorBoxForm(item);
                                            }
                                            }}
                                        >
                                            <th className="" scope="row" style={{ paddingLeft: 0 }}>
                                            {item?.group === 1 ? (
                                                <i
                                                style={{ fontSize: 12, width: 20, padding: '5px 21px 5px 12px' }}
                                                className={item?.open ? 'fa fa-chevron-down' : 'fa fa-chevron-right'}
                                                aria-hidden="true"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    // Handle normal group expansion
                                                    const list = this.state.sensorBoxList.slice();
                                                    let index = list.findIndex((d) => item?._id === d?._id);
                                                    list[index].open = !list[index].open;
                                                    this.setState({ sensorBoxList: list });
                                                }}
                                                ></i>
                                            ) : (
                                                <i
                                                title={item?.is_online ? 'Online' : 'Offline'}
                                                style={{ padding: '5px 21px 5px 12px' }}
                                                className={
                                                    item?.is_online ? 'fa fa-signal online-status' : 'fa fa-ban offline-status'
                                                }
                                                aria-hidden="true"
                                                ></i>
                                            )}
                                            </th>
                                            <td
                                            className="text-truncate"
                                            title={item && item.group ? item.name : item && item.sensor_box_name}
                                            >

                                            {/* Add indentation for asset group children */}
                                            {group.groupId !== 'ungrouped' && (
                                                <span className="asset-group-indent"></span>
                                            )}
                                            {demoCheck
                                                ? item && item.group
                                                ? item.name
                                                : item.alias || item.sensor_box_name
                                                : item && item.group
                                                ? item.name
                                                : item && item.alias
                                                ? item.alias
                                                : item.sensor_box_name}
                                            {item && item.sensor_box_source === 'external' && item.group !== 1 && (
                                                <i className="fa fa-podcast ml-2" style={{ fontSize: '14px', color: '#1890ff' }} aria-hidden="true"></i>
                                            )}
                                            </td>
                                            <td
                                            className="text-truncate"
                                            title={
                                                item?.last_updated_time
                                                ? moment(item?.last_updated_time).format('MM/DD/YYYY, HH:mm:ss')
                                                : '-'
                                            }
                                            >
                                            {item?.last_updated_time
                                                ? moment(item?.last_updated_time).format('MM/DD/YYYY, HH:mm:ss')
                                                : '-'}
                                            </td>
                                            <td className="text-center" title={item.status === -1 ? 'Algorithm not defined' : ''}>
                                            <i
                                                className={`fa fa-circle ${Utils.getSensorStatus(item.status)} px-3`}
                                                aria-hidden="true"
                                            ></i>
                                            </td>

                                            <td className="text-center">
                                            {(item?.device_type === 'general' || item?.group === 1) && (
                                                <i
                                                className="fa fa-eye cursor-pointer px-3"
                                                onClick={(e: any) => {
                                                    e.stopPropagation();
                                                    this.showSensordataModal(item);
                                                }}
                                                aria-hidden="true"
                                                ></i>
                                            )}
                                            </td>
                                            <td className="text-center">
                                            <i
                                                className="fa fa-download cursor-pointer px-3"
                                                onClick={(e: any) => {
                                                e.stopPropagation();
                                                this.showExportModal(item);
                                                }}
                                                aria-hidden="true"
                                            ></i>
                                            </td>
                                            <td className="text-center">
                                            {((item?.device_type === 'general' && item?.group === 0) ||
                                                (item?.group === 1 && item?.sensorboxes?.length > 1)) && (
                                                <i
                                                className="fa fa-line-chart px-3"
                                                onClick={(e: any) => {
                                                    e.stopPropagation();
                                                    item?.group === 0
                                                    ? this.showGraphModal(item)
                                                    : this.showGraphModalForGroup(item);
                                                }}
                                                aria-hidden="true"
                                                ></i>
                                            )}
                                            </td>

                                            <td className="text-center">
                                            {item?.group === 0 && (
                                                <i
                                                className="fa fa-wrench px-3"
                                                onClick={(e: any) => {
                                                    e.stopPropagation();
                                                    this.showMaintenanceModal(item);
                                                }}
                                                aria-hidden="true"
                                                ></i>
                                            )}
                                            </td>
                                            <td className="text-center">
                                            {item?.category !== 'generator' && item?.group === 1 ? (
                                                <i
                                                className="fa fa-file-text-o cursor-pointer px-3"
                                                onClick={(e: any) => {
                                                    e.stopPropagation();
                                                    this.showAssetLogsModal(item);
                                                }}
                                                aria-hidden="true"
                                                ></i>
                                            ) : (
                                                <i
                                                className="fa fa-file-text-o cursor-pointer px-3"
                                                onClick={(e: any) => {
                                                    e.stopPropagation();
                                                    this.showAlertLogsModal(item);
                                                }}
                                                aria-hidden="true"
                                                ></i>
                                            )}
                                            </td>
                                            {canCreateEditTickets && (
                                            <td className="text-center">
                                                {item?.group === 0 && (
                                                <i
                                                    className="fa fa-flag cursor-pointer px-3"
                                                    onClick={(e: any) => {
                                                    e.stopPropagation();
                                                    this.showIssueCreationPage(item);
                                                    }}
                                                    aria-hidden="true"
                                                ></i>
                                                )}
                                            </td>
                                            )}
                                            {(authStore?.currentUser?.active_role?.role_type !== 4 && authStore?.currentUser?.active_role?.role_type !== 2) && (
                                            <td className="text-left">
                                                {item?.device_config_status && (
                                                <span
                                                    className="btn-link td-data"
                                                    onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.showDeviceLog(item);
                                                    }}
                                                >
                                                    {constants.deviceStatus.get(item?.device_config_status)?.text || ''}
                                                </span>
                                                )}
                                            </td>
                                            )}
                                            {(authStore?.isSuperAdmin) && (() => {
                                            const matchedStatus = this.state.sensorboxGroupStatuses.find(
                                                (status: any) => status.sensorboxId === item._id
                                            );

                                            return matchedStatus ? (
                                                <td className="text-center px-3" key={matchedStatus.sensorboxId}>
                                                {matchedStatus.status === 'YES' ? (
                                                    <img
                                                    src={CheckIcon}
                                                    alt="Check"
                                                    style={{ width: 16, height: 16 }}
                                                    title="Limits Matched"
                                                    />
                                                ) : matchedStatus.status === 'NO' ? (
                                                    <img
                                                    src={WarningIcon}
                                                    alt="Cross"
                                                    style={{ width: 16, height: 16 }}
                                                    title="New Limits Available"
                                                    />
                                                ) : matchedStatus.status === 'NEW' ? (
                                                    <img
                                                    src={CrossIcon}
                                                    alt="NEW"
                                                    style={{ width: 16, height: 16 }}
                                                    title="Limits Missing"
                                                    />
                                                ) : (
                                                    <img
                                                    src={NAIcon}
                                                    alt="NA"
                                                    style={{ width: 30, height: 30 }}
                                                    title="Not Applicable"
                                                    />
                                                )}
                                                </td>
                                            ) : null;
                                            })()}
                                            {(authStore?.isOrgAdmin()) && (
                                                <td className="text-center">
                                                    {(() => {
                                                        const assetId = item?.group === 0 ? item?.sensor_box_name : item?._id;
                                                        const rulesStatus = this.state.rulesStatusMap[assetId];
                                                        if (!rulesStatus || !rulesStatus.asset_type) {
                                                            return <img src={NAIcon} alt="NA" style={{ width: 30, height: 30 }} title="Asset Type Not Present" />;
                                                        } else if (rulesStatus.hasRules) {
                                                            const lastUpdated = rulesStatus.updatedAt 
                                                                ? moment(rulesStatus.updatedAt).format('MM/DD/YYYY')
                                                                : 'N/A';
                                                            return <img src={CheckIcon} alt="Check" style={{ width: 16, height: 16 }} title={`Last Updated: ${lastUpdated}\nRules Count: ${rulesStatus.rulesCount || 0}`} />;
                                                        } else {
                                                            return <img src={CrossIcon} alt="Cross" style={{ width: 16, height: 16 }} title="No Rules Found" />;
                                                        }
                                                    })()}
                                                </td>
                                            )}
                                        </tr>

                                        {/* Normal Group Items (when expanded) */}
                                        {item?.open && item?.group === 1 && (
                                            <>
                                            {item?.sensorboxes?.map((box: any, i: number) => (
                                                <tr className="cursor-pointer" onClick={() => { this.showSensorBoxForm(box) }}>
                                                <th className="" scope="row">
                                                    {
                                                    <i title={box?.is_online ? 'Online' : 'Offline'} className={ box?.is_online ? 'fa fa-signal online-status' : 'fa fa-ban offline-status'} aria-hidden="true"></i>
                                                    }                                                                
                                                </th>
                                                
                                                <td className="text-truncate" title={box?.sensor_box_name}>
                                                    {
                                                        demoCheck ?
                                                        box?.alias || box?.sensor_box_name :
                                                        (box?.alias ? box?.alias : box?.sensor_box_name) 
                                                    }
                                                    {box && box.sensor_box_source === 'external' && box.group !== 1 && (
                                                        <i className="fa fa-podcast ml-2" style={{ fontSize: '14px', color: '#1890ff' }} aria-hidden="true"></i>
                                                    )}
                                                </td>
                                                <td className="text-truncate">
                                                    {box?.last_updated_time ? moment(box?.last_updated_time).format('MM/DD/YYYY, HH:mm:ss') : '-'}
                                                </td>
                                                <td className="text-center" title = {box.status === -1 ? 'Algorthm not defined' : ''}>
                                                    <i className={`fa fa-circle ${Utils.getSensorStatus(box.status)} px-3`} aria-hidden="true"></i>
                                                </td>
                                                <td className="text-center">
                                                {box?.device_type === 'general' &&
                                                    <i className="fa fa-eye cursor-pointer px-3" onClick={(e : any) => { e.stopPropagation(); this.showSensordataModal(box)}} aria-hidden="true"></i>
                                                }
                                                </td>
                                                <td className="text-center">
                                                    <i className="fa fa-download cursor-pointer px-3" onClick={(e : any) => { e.stopPropagation(); this.showExportModal(box);}} aria-hidden="true"></i>
                                                </td>
                                                <td className="text-center">
                                                    <i className="fa fa-line-chart px-3" onClick={(e : any) =>{ e.stopPropagation(); this.showGraphModal(box);}} aria-hidden="true"></i>
                                                </td>
                                                <td className="text-center">
                                                    <i className="fa fa-wrench px-3" onClick={(e : any) => { e.stopPropagation(); this.showMaintenanceModal(box);}} aria-hidden="true"></i>
                                                </td>
                                                <td className="text-center">
                                                <i className="fa fa-file-text-o cursor-pointer px-3" onClick={(e : any) => { e.stopPropagation(); this.showAlertLogsModal(box);}} aria-hidden="true"></i>
                                                </td>
                                                {canCreateEditTickets &&
                                                <td className="text-center">
                                                <i className="fa fa-flag cursor-pointer px-3" onClick={(e : any) => { e.stopPropagation(); this.showIssueCreationPage(box);}} aria-hidden="true"></i>
                                                </td>
                                                }

                                                {(authStore?.currentUser?.active_role?.role_type !== 4 && authStore?.currentUser?.active_role?.role_type !== 2) &&
                                                <td className="text-left">
                                                {box?.device_config_status &&
                                                    <span className="btn-link td-data" onClick={(e) => {
                                                        e.stopPropagation();
                                                        this.showDeviceLog(box);
                                                    }}>
                                                    {constants.deviceStatus.get(box?.device_config_status)?.text || ''}
                                                    </span>
                                                }
                                                </td>
                                                }
                                                {authStore?.isSuperAdmin && (() => {
                                                    const matchedStatus = this.state.sensorboxStatuses.find(
                                                        (status: any) => status.sensorboxId === box._id
                                                    );

                                                    return matchedStatus ? (
                                                        <td className="text-center" key={matchedStatus.sensorboxId}>
                                                            {matchedStatus.status === "YES" ? (
                                                                <img src={CheckIcon} alt="Check" style={{ width: 16, height: 16 }} title="Limits Matched" />
                                                            ) : matchedStatus.status === "NO" ? (
                                                                <img src={WarningIcon} alt="Cross" style={{ width: 16, height: 16 }} title='New Limits Available' />
                                                            ) : matchedStatus.status === "NEW" ? (
                                                                <img src={CrossIcon} alt="New" style={{ width: 16, height: 16 }} title='Limits Missing' />
                                                            ): (
                                                                <img src={NAIcon} alt="NA" style={{ width: 30, height: 30 }} title='Not Applicable' />
                                                            )}
                                                        </td>
                                                    ) : null;
                                                })()}
                                                {(authStore?.isOrgAdmin()) && (
                                                    <td className="text-center">
                                                        {(() => {
                                                            const assetId =  box.sensor_box_name;
                                                            const rulesStatus = this.state.rulesStatusMap[assetId];
                                                            if (!rulesStatus || !rulesStatus.asset_type) {
                                                                return <img src={NAIcon} alt="NA" style={{ width: 30, height: 30 }} title="Asset Type Not Present" />;
                                                            } else if (rulesStatus.hasRules) {
                                                                const lastUpdated = rulesStatus.updatedAt 
                                                                    ? moment(rulesStatus.updatedAt).format('MM/DD/YYYY')
                                                                    : 'N/A';
                                                                return <img src={CheckIcon} alt="Check" style={{ width: 16, height: 16 }} title={`Last Updated: ${lastUpdated}\nRules Count: ${rulesStatus.rulesCount || 0}`} />;
                                                            } else {
                                                                return <img src={CrossIcon} alt="Cross" style={{ width: 16, height: 16 }} title="No Rules Found" />;
                                                            }
                                                        })()}
                                                    </td>
                                                )}
                                                </tr>
                                            ))}
                                            </>
                                        )}
                                        </React.Fragment>
                                    );
                                    })}
                                </React.Fragment>
                            ))
                            ) : null}
                        </tbody>
                        </table>
                    </div>
                    ) : (
                    <div className="text-center w-100 no-card-ph">
                        <div className="no-result-container">
                        {!this.state.isLoading && (
                            <p className="no-cards">
                            {' '}
                            {this.state.searchFilter === '' ? 'No data found!' : 'No results found!'}
                            </p>
                        )}
                        </div>
                    </div>
                    )}

                <div className="pagination-container">

                    {Math.ceil(this.state.sensorBoxCount / Constants.maxLimit) > 1 ?

                        <Pagination
                            hideNavigation
                            activePage={this.state.currentPage}
                            itemsCountPerPage={Constants.maxLimit}
                            totalItemsCount={this.state.sensorBoxCount}
                            itemClass={"item-class"}
                            activeClass={"active-class"}
                            pageRangeDisplayed={5}
                            onChange={(pageNumber) => {
                                this.setState({ isLoading: true }, () => {
                                    this.getSensorBoxes(pageNumber, system_id , status)
                                })
                            }}
                        />

                        : null
                    }
                </div>


                {this.state.isLoading ?
                    <LoadingWheel />
                    : null}
                <SensorData 
                    show={this.state.showSensorDataModal}
                    closeModal={this.closeSensordataModal} 
                    sensorBox={this.state.selecetedSensorBox}/>
                <ExportModal
                    show={this.state.showExportModal}
                    closeModal={this.closeExportModal}
                    SensorBoxName={this.state.selectedSensorBoxName}
                    GroupId={this.state.selectedGroupId}
                    orgId = {this.state.organizationFilter?._id}
                />
                {this.state.showGraphModal
                    ? <GraphModal
                        SensorBoxName={this.state.selectedSensorBoxName}
                        closeGraphModal={this.closeGraphModal}
                        sensorBox={this.state.selecetedSensorBox}
                    />
                    : null}
                {this.state.showGraphModalForGroup
                    ? <GraphModalGroup
                        sensorGroupName={this.state.selecetedSensorBox.name}
                        closeGraphModal={this.closeGroupGraphModal}
                        sensorGroup={this.state.selecetedSensorBox}
                    />
                    : null}
                <MaintenanceModal
                    show={this.state.showMaintenanceModal}
                    onClose={this.closeMaintenanceModal}
                    sensorBoxName={this.state.selectedSensorBoxName}
                    sensorBox={this.state.selecetedSensorBox}
                />
                {this.state.showAlertLogsModal ?
                    <AlertLogsModal
                        show={this.state.showAlertLogsModal}
                        onClose={this.closeAlertLogsModal}
                        sensorBoxName={this.state.selectedSensorBoxName}
                        sensorBox={this.state.selecetedSensorBox}
                        showLogDataModal={(logData:any) => this.showLogDataModal(logData)}
                        showInvalidRangeAlertModal={(logData:any) => this.showInvalidRangeAlertModal(logData)}
                        lastTab={this.state.lastTab}
                        onTabChange={(tab: string) => this.setState({ lastTab: tab })}
                    /> : null }

                {this.state.showAssetLogsModal ?
                    <AssetLogsModal
                        show={this.state.showAssetLogsModal}
                        onClose={this.closeAssetLogsModal}
                        sensorBoxName={this.state.selectedSensorBoxName}
                        asset_id={this.state.selectedGroupId || this.state.selectedSensorBoxName}
                        sensorBox={this.state.selecetedSensorBox}
                        showLogDataModal={(logData:any) => this.showAssetLogDataModal(logData)}
                        showInvalidRangeAlertModal={(logData:any) => this.showInvalidRangeAlertModal(logData)}
                        lastTab={this.state.lastTab}
                        onTabChange={(tab: string) => this.setState({ lastTab: tab })}
                    /> : null }

                {this.state.showAssetDetailsModal ?
                    <AssetDetailsModal
                        show={this.state.showAssetDetailsModal}
                        onClose={this.closeAssetDetailsModal}
                        asset={this.state.selectedAsset}
                        organisationId={org_id ? org_id : this.state.organizationFilter ? this.state.organizationFilter._id : ''}
                    /> : null }

                {this.state.isLogDataVisible ?
                    <LogDataModal 
                        {...this.logDataModalProps()}
                        sensorBoxName = {this.state.selectedSensorBoxName}
                        isVisible={this.state.isLogDataVisible}
                    /> : null}

                {this.state.isInvalidRangeDataVisible ?
                    <InvalidRangeAlertModal
                        logData={this.state.invalidRangeAlertData}
                        sensorBoxName = {this.state.invalidRangeAlertData.sensorbox_name}
                        onClose={this.closeInvalidRangeAlertModal}
                        isVisible={this.state.isInvalidRangeDataVisible}
                    /> : null }

                {this.state.createGroupModalVisible ?
                    <CreateGroupModal
                            show={this.state.createGroupModalVisible}
                            onClose={()=> this.setState({ createGroupModalVisible: false })}
                            // note : temp solution for the org admin access to all org
                            organisationId={this.state.organizationFilter ? this.state.organizationFilter._id : ''}
                            onSave={() => {
                                this.setState({isLoading : true}, () => {
                                this.getSensorBoxes(1)
                                })
                            }}
                    /> : null }

                {this.state.DeviceConfigLogModalVisible ?
                    <DeviceConfigLogModal
                            show={this.state.DeviceConfigLogModalVisible}
                            onClose={()=> this.setState({ DeviceConfigLogModalVisible: false })}
                            sensorbox={this.state.selectedSensorBox}
                    /> : null }

                {this.state.visible ?
                        <SensorBoxForm 
                        sensorbox = {this.state.selectedSensorBox} updateSensorBoxList = {this.getSensorBoxes} 
                        clearSelectedSensorBox = {this.clearSelect} shouldPageChange={this.shouldPageChange} 
                        setVisibleClose={this.setVisible}
                        updateEventSourceListener={this.listenAndUpdateSensordata}
                        organisationId={org_id ? org_id : this.state.organizationFilter ? this.state.organizationFilter._id : ''}
                        organisationList = {this.state.organizationList ? this.state.organizationList : []}/>
                        : null}

                <ResetHardeleteSensorbox
                            title={isSuperAdmin ? "Reset / Hard Delete Sensorbox" : 'Reset Sensorbox'}
                            message={isSuperAdmin ? "Do you want to" : "Are you sure want to reset this sensorbox"}
                            visible = {this.state.showResetSensorBoxModal}
                            confirm ={"YES"}
                            action={(data? : any) => (this.resetSensorBox(this.state.selectedSensorBox , data))}
                            toggleVisibility={this.closeResetSensorBoxModal}
                            isSuperAdmin = {isSuperAdmin}
                />

                {authStore?.currentUser?.access?.includes(create_or_update_sensorboxes_assets) && !system_id && !status &&
                    <div className="">
                        <Dropdown drop="up" onSelect={this.onAddBtnClick}>
                        <Dropdown.Toggle
                            className="add-icon-dashboard"
                            bsPrefix={'add'}
                        >
                            <i className="fa fa-plus" aria-hidden="true"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dashboard-add-menu">
                            <Dropdown.Item eventKey="sensorbox" className="dashboard-add-menu-item">
                            <span>
                                <img className="mr-2" src={sensorIcn} height={12} alt=''/>
                                Add sensor box
                            </span>
                            </Dropdown.Item>
                            <Dropdown.Item eventKey="group" className="dashboard-add-menu-item">
                            <span>
                                <img className="mr-2" src={groupIcn} height={12} alt=''/>
                                Create asset
                            </span>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                        </Dropdown>
                    </div>
                }
                </div>
        )
    }
}

export default withRouter(UserList)